<template>
  <div class="page-container">
    <!-- 顶部查询栏 -->
    <el-card class="search-bar">
      <el-form :inline="true">
        <el-form-item label="指令名称">
          <el-input
            v-model="search.directiveName"
            placeholder="请输入指令名称"
            clearable
            @keyup.enter="loadTemplates(1)"
          />
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="loadTemplates(1)"
          >查询</el-button>

<!--          <el-button-->
<!--            type="success"-->
<!--            icon="el-icon-download"-->
<!--            @click="downloadExcelTemplate"-->
<!--          >下载Excel模板</el-button>-->

          <el-button
            type="primary"
            icon="el-icon-plus"
            @click="createNewTemplate"
          >新建模板</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 模板列表 -->
    <el-card class="table-card">
      <el-table
        :data="directives"
        border
        stripe
        v-loading="loading"
        empty-text="暂无数据"
      >
        <el-table-column prop="directiveName" label="查询指令" min-width="150" />
<!--        <el-table-column prop="queryDirective" label="查询指令" min-width="200" show-overflow-tooltip />-->
        <el-table-column label="创建时间" width="360">
          <template v-slot="scope">
            {{ formatDate(scope.row.createdAt	) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="360" fixed="right">
          <template v-slot="scope">
            <el-button
              type="primary"
              size="small"
              icon="el-icon-edit"
              @click="openEditDialog(scope.row)"
            >编辑</el-button>

            <el-button
              type="danger"
              size="small"
              icon="el-icon-delete"
              @click="removeTemplate(scope.row.id)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination-bar"
        :current-page="page"
        :page-size="size"
        :total="total"
        :page-sizes="[10, 20, 50]"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="loadTemplates"
      />
    </el-card>

    <!-- 账户编辑弹窗 -->
    <el-dialog
      :visible.sync="editDialogVisible"
      :title="'账户管理 - ' + (currentDirective ? currentDirective.directiveName : '')"
      width="1200px"
      top="5vh"
    >
      <div class="dialog-toolbar">
        <el-upload
          :action="uploadUrl"
          :show-file-list="false"
          accept=".xlsx,.xls"
          :on-success="handleImportSuccess"
          :before-upload="beforeUpload"
          :data="{ directiveId: currentDirective ? currentDirective.id : '', userId: userId }"
        >
          <el-button type="primary" icon="el-icon-upload">导入Excel</el-button>
        </el-upload>

        <div>
          <el-button type="info" icon="el-icon-download" @click="downloadExcelTemplate">下载模板</el-button>
          <el-button type="success" icon="el-icon-plus" @click="addAccountRow">新增账户</el-button>
<!--          <el-button type="primary" icon="el-icon-check" @click="saveAccounts">保存</el-button>-->
        </div>
      </div>

      <el-table
        :data="editingAccounts"
        border
        stripe
        height="500"
        class="account-table"
        v-loading="accountLoading"
        empty-text="暂无账户数据，请添加或导入"
      >


        <el-table-column label="管理账户id" min-width="150">
          <template v-slot="scope">
            <el-input v-model="scope.row.controlAccountId" placeholder="请输入管理账户id" />
          </template>
        </el-table-column>
        <el-table-column label="账户名称" min-width="150">
          <template v-slot="scope">
            <el-input v-model="scope.row.accountName" placeholder="请输入账户名称" />
          </template>
        </el-table-column>

        <el-table-column label="账户ID" min-width="150">
          <template v-slot="scope">
            <el-input v-model="scope.row.accountId" placeholder="请输入账户ID" />
          </template>
        </el-table-column>

        <el-table-column label="计划名称" min-width="150">
          <template v-slot="scope">
            <el-input v-model="scope.row.campaignName" placeholder="请输入计划名称" />
          </template>
        </el-table-column>

        <el-table-column label="下载url" min-width="200">
          <template v-slot="scope">
            <el-input v-model="scope.row.downloadUrl" placeholder="请输入下载url" />
          </template>
        </el-table-column>

        <el-table-column label="deeplink地址" min-width="200">
          <template v-slot="scope">
            <el-input v-model="scope.row.deeplink" placeholder="请输入deeplink" />
          </template>
        </el-table-column>

        <el-table-column label="落地页URL" min-width="200">
          <template v-slot="scope">
            <el-input v-model="scope.row.landingPageUrl" placeholder="请输入落地页URL" />
          </template>
        </el-table-column>

        <el-table-column label="点击监控链接" min-width="200">
          <template v-slot="scope">
            <el-input v-model="scope.row.clickMonitorUrl" placeholder="请输入点击监控链接" />
          </template>
        </el-table-column>

        <el-table-column label="状态" width="80" align="center">
          <template v-slot="scope">
            <el-switch
              v-model="scope.row.status"
              :active-value="true"
              :inactive-value="false"
            />
          </template>
        </el-table-column>

        <el-table-column label="操作" width="80" fixed="right">
          <template v-slot="scope">
            <el-button
              type="danger"
              icon="el-icon-delete"
              circle
              size="mini"
              @click="removeAccountRow(scope.$index, scope.row)"
            />
          </template>
        </el-table-column>

      </el-table>

      <div class="dialog-footer">
        <el-button type="primary" @click="saveAccounts">保存账户信息</el-button>
        <el-button @click="editDialogVisible = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>


<script>
import axios from 'axios'
import { format } from 'date-fns'

export default {
  data() {
    return {
      userId: '',
      page: 1,
      size: 10,
      total: 0,
      loading: false,
      accountLoading: false,
      directives: [],
      search: {
        directiveName: ''
      },
      editDialogVisible: false,
      currentDirective: null,
      editingAccounts: [],
      uploadUrl: 'https://control.zjwec.cn/api/qttad/accounts/import',
    }
  },
  created() {
    // 从路由参数获取用户ID
      this.userId = this.$route.query.userId

    if (!this.userId) {
      // 使用Element UI的消息提示
      this.$message.warning('您得先登录')

      // 设置延迟跳转让用户看到提示
      setTimeout(() => {
        // 重定向到登录页面（外部链接）
        window.location.href = 'https://control.zjwec.cn/page/end/login.html'
      }, 1500)  // 1.5秒后跳转

        // 终止后续执行
    }else {
      // 如果获取到userId则正常加载
      this.loadTemplates(1)
    }


  },
  methods: {
    formatDate(dateObj) {
      // 检查是否为结构化对象
      if (dateObj && typeof dateObj === 'object' && 'year' in dateObj) {
        const { year, monthValue, dayOfMonth, hour, minute, second } = dateObj;
        // 构造 ISO 8601 格式字符串（兼容 new Date()）

        const dateStr = `${year}-${String(monthValue).padStart(2, '0')}-${String(dayOfMonth).padStart(2, '0')} ${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}:${String(second).padStart(2, '0')}`;

        return dateStr;
      }
      // 处理其他格式（如时间戳或字符串）
      const date = new Date(dateObj);
      return isNaN(date) ? 'Invalid Date' : format(date, 'yyyy-MM-dd HH:mm');
    },
    async loadTemplates(page) {
      this.page = page
      this.loading = true

      try {
        const res = await axios.get('https://control.zjwec.cn/api/qttad/directives', {
          params: {
            userId: this.userId,
            page: this.page,
            size: this.size,
            directiveName: this.search.directiveName
          },
        })

        this.directives = res.data.records
        this.total = res.data.total
      } catch (error) {
        console.error(error)
        this.$message.error('加载模板失败: ' + error.message)
      } finally {
        this.loading = false
      }
    },

    handleSizeChange(size) {
      this.size = size
      this.loadTemplates(1)
    },

    downloadExcelTemplate() {
      window.open('https://control.zjwec.cn/api/qttad/template', '_blank')
    },

    createNewTemplate() {
      this.$prompt('请输入模板名称', '新建模板', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^.{2,50}$/,
        inputErrorMessage: '模板名称长度需在2-50个字符'
      }).then(({ value }) => {
        const newTemplate = {
          userId: this.userId,
          directiveName: value,
          queryDirective: ''
        }

        axios.post('https://control.zjwec.cn/api/qttad/directives', newTemplate)
          .then(res => {
            this.$message.success('模板创建成功')
            this.loadTemplates(1)
          })
          .catch(error => {
            this.$message.error('创建失败: ' + error.message)
          })
      }).catch(() => {})
    },

    async removeTemplate(id) {
      try {
        await this.$confirm('确认删除该模板？其下所有账户数据也将被删除', '警告', {
          type: 'warning',
          confirmButtonText: '确认删除',
          cancelButtonText: '取消'
        })

        await axios.delete(`https://control.zjwec.cn/api/qttad/directives/${id}`, {
          params: { userId: this.userId }
        })

        this.$message.success('模板删除成功')
        this.loadTemplates(this.page)
      } catch (error) {
        console.error(error)
        if (error.response) {
          this.$message.error(error.response.data || '删除失败')
        }
      }
    },

    async openEditDialog(row) {
      console.log(row)
      this.currentDirective = row
      this.accountLoading = true
      this.editDialogVisible = true

      try {
        const res = await axios.get('https://control.zjwec.cn/api/qttad/accounts', {
          params: {
            directiveId: String(row.id),
            userId: this.userId
          }
        })
        this.editingAccounts = res.data
      } catch (error) {
        console.error(error)
        if (error.response) {
          this.$message.error(error.response.data || '加载账户失败')
        }
      } finally {
        this.accountLoading = false
      }
    },

    addAccountRow() {
      this.editingAccounts.unshift({
        controlAccountId: '',
        accountName: '',
        accountId: '',
        campaignName: '',
        downloadUrl: '',
        deeplink: '',
        landingPageUrl: '',
        clickMonitorUrl: '',
        weichatBackendUserId: '',
        status: true,
        directiveId: this.currentDirective.id
      })
    },

    async removeAccountRow(index, row) {
      console.log("正在删除的行数据:", row);

      // 如果 row.id 存在（有效ID）
      if (row.id) {
        try {
          // 调用删除接口
          const response = await  axios.get("https://control.zjwec.cn/api/qttad/delete", {
            params: { id: row.id }
          });

          // 根据响应结果处理
          if (response.data === 1) {
            console.log("后端删除成功，移除本地行");
            this.editingAccounts.splice(index, 1);
          } else {
            console.error("后端删除失败，保留数据");
            this.$message.error("删除失败，请重试");
          }
        } catch (error) {
          console.error("删除请求失败:", error);
          this.$message.error("删除请求失败: " + error.message);
        }
      }
      // 如果 row.id 不存在（新增未提交的行）
      else {
        console.log("无ID行，直接移除");
        this.editingAccounts.splice(index, 1);
      }
    },

    async saveAccounts() {
      try {
        await axios.post('https://control.zjwec.cn/api/qttad/accounts/update', {
          directive_id: this.currentDirective.id,
          user_id: this.userId,
          accounts: this.editingAccounts,
        })

        this.$message.success('账户信息保存成功')
        this.editDialogVisible = false
        this.loadTemplates(this.page)
      } catch (error) {
        console.error(error)
        if (error.response) {
          this.$message.error(error.response.data || '保存失败')
        }
      }
    },

    beforeUpload(file) {
      const isExcel = file.type.includes('excel') ||
        file.name.endsWith('.xlsx') ||
        file.name.endsWith('.xls')

      if (!isExcel) {
        this.$message.error('请上传Excel文件（.xlsx 或 .xls 格式）')
        return false
      }

      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('文件大小不能超过10MB')
        return false
      }

      return true
    },

    handleImportSuccess(res) {
      if (res === '导入成功') {
        this.$message.success('Excel导入成功')
        this.openEditDialog(this.currentDirective)
      } else {
        this.$message.error(res || '导入失败')
      }
    }
  }
}
</script>

<style scoped>
.page-container {
  padding: 20px;
  background-color: #f5f7fa;
}

.search-bar {
  margin-bottom: 20px;
  background: #fff;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.table-card {
  margin-bottom: 20px;
  background: #fff;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.pagination-bar {
  margin-top: 20px;
  text-align: right;
}

.dialog-toolbar {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
  padding: 0 10px;
}

.account-table {
  margin-bottom: 20px;
  border: 1px solid #ebeef5;
}

.dialog-footer {
  text-align: right;
  padding-top: 15px;
  border-top: 1px solid #ebeef5;
  margin-top: 15px;
}

::v-deep .el-table th {
  background-color: #f5f7fa;
  font-weight: bold;
  color: #606266;
}

::v-deep .el-dialog__body {
  padding: 20px;
}

::v-deep .el-button {
  padding: 8px 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/qtt/qttZlControl.vue